// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__AiDF-","text":"styles_text__hHp8D"};